import React from "react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Edit, Plus, Send, Trash2, UserPlus } from "lucide-react";
import { flatClients } from "../../lib/clientList";

// Client groups with locations and bulk messaging.
const GroupsTab = ({
  clientGroups,
  clients,
  deleteGroup,
  setEditingGroup,
  setGroupMessageOpen,
  setGroupMessageTarget,
  setGroupMessageText,
  setGroupOpen,
  setNewGroup,
}) => {
  return (
    <div className="groups-view">
      <div className="view-header">
        <h1>Grupy klientów</h1>
        <Button onClick={() => { setEditingGroup(null); setNewGroup({ name: "", description: "", location: "", client_ids: [] }); setGroupOpen(true); }}>
          <Plus size={18} /> Nowa grupa
        </Button>
      </div>

      {clientGroups.length === 0 ? (
        <Card className="empty-state">
          <CardContent className="empty-content">
            <UserPlus size={48} strokeWidth={1} />
            <h3>Brak grup</h3>
            <p>Utwórz grupy klientów aby łatwiej zarządzać treningami</p>
          </CardContent>
        </Card>
      ) : (
        <div className="groups-grid">
          {clientGroups.map(group => {
            const groupClients = flatClients(clients).filter(c => group.client_ids.includes(c.id));
            return (
              <Card key={group.id} className="group-card">
                <CardHeader>
                  <div className="group-card-header">
                    <div>
                      <CardTitle>{group.name}</CardTitle>
                      {group.description && <CardDescription>{group.description}</CardDescription>}
                      {group.location && <CardDescription style={{fontSize:12, marginTop:2}}>📍 {group.location}</CardDescription>}
                    </div>
                    <div className="group-actions">
                      <Button variant="ghost" size="sm" onClick={() => {
                        setGroupMessageTarget(group);
                        setGroupMessageText("");
                        setGroupMessageOpen(true);
                      }}>
                        <Send size={14} />
                      </Button>
                      <Button variant="ghost" size="sm" onClick={() => {
                        setEditingGroup(group);
                        setNewGroup({ name: group.name, description: group.description || "", location: group.location || "", client_ids: group.client_ids });
                        setGroupOpen(true);
                      }}>
                        <Edit size={14} />
                      </Button>
                      <Button variant="ghost" size="sm" onClick={() => deleteGroup(group.id)}>
                        <Trash2 size={14} />
                      </Button>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="group-members">
                    <Badge variant="secondary">{group.client_ids.length} członków</Badge>
                    <div className="group-avatars">
                      {groupClients.slice(0, 5).map(c => (
                        <Avatar key={c.id} className="group-avatar">
                          <AvatarFallback>{c.name?.charAt(0)}</AvatarFallback>
                        </Avatar>
                      ))}
                      {groupClients.length > 5 && <span className="group-more">+{groupClients.length - 5}</span>}
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default GroupsTab;
